module.exports = __webpack_public_path__ + "static/media/chevron-up.6c8db30f.svg";